import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { HeaderService } from './header.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  providers: [HeaderService]
})
export class HeaderModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: HeaderModule,
      providers: [
        HeaderService
      ]
    };
  }
}
